export default "__VITE_ASSET__DEQiqlWK__"